<template>
  <div>
    <!-- <HotelHero class="hotellisthero"></HotelHero> -->
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex py-5">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3 text-white">Your Order details</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="container">
        <section class="section">
          <div>
            <div class="row">
              <div class="col-md-12">
                <!-- <card>
                  <div class="col-md-6">
                      <a class="btn btn-primary mt-5" style="color: white"
                        >Confirm Payment</a
                      >
                    </div>
                    <div class="col-md-6">
                      <a class="btn btn-sm btn-notice mt-5">Cancel Order</a>
                    </div>
                </card> -->

                <card shadow>
                  <div class="row">
                    <div class="col-lg-12 mb-3">
                 <h2> <strong>Dear {{ name }} </strong> </h2>
                  <h4 style="color: green">
                      Thank you for placing your order with us<br />
                      
                           <span style="color: orange"> Order Date: <strong> {{ date }} </strong></span>-
                           <span style="color: orange"> Your Order Number: <strong> {{ orderid }} </strong></span
                      >  
                    </h4>
                  <!-- <div class="alert alert-warning mt-2" style="color: white">
                    Pending Approval
                  </div> -->
                    </div>
                    <div class="col-lg-12 mb-3">
                 
                         <div v-if="status == 'sent'">
                              <strong class="alert alert-info">
                                Awaiting Approval
                              </strong>
                            </div>
                            <div v-if="status == 'accepted'">
                              <strong class="alert alert-success">
                                Confirmed
                              </strong>
                            </div>
                            <div v-if="status == 'declined'">
                              <strong class="alert alert-warning">
                                Rejected / Cancelled
                              </strong>
                            </div>
                            <div v-if="status != 'declined' && status != 'accepted' && status != 'sent'">
                              <strong class="alert alert-warning">
                                {{ status }}
                              </strong>
                            </div>
                    </div>
                  </div>
                  

                  <div class="mt-2">
                   
                    We have recieved your order and will be able to process once
                    a payment has been made. You can make the payment using one
                    of the methods below:<span style="color: orange">
                      (Only make the payment once you have recieved confirmation
                      from our team) </span
                    ><br /><br />
                    When making your payment, please mention the order number
                    given below as a note / reference or let our team know.

                    <!-- display:none -->
                    <div v-if="status == 'accepted'">
                      <div class="row">
                        <div class="col-md-12">
                          <h3 class="mt-5 text-center">Bank Details </h3>
                        </div>
                        <div class="mt-5 col-md-6 box">
                            <h4 class="bankname">IDBI Bank</h4>
                            <p>Branch: <strong class="branch">Ulhasnagar</strong></p>
                          <p>A/C Name :
                            <strong class="acname">Deepak Travel World</strong>
                          </p>
                          <p>A/C No : <strong class="acno">0221102000025027 </strong></p>
                          <p> RTGS/ NEFT IFSC: <strong class='code'>IBKL0000221</strong></p>
                        </div>
                        <div class="mt-5 col-md-6 col-sm-12 box">
                          <h4 class="bankname">Axis Bank</h4>
                          <p>Branch: <strong class="branch">Ulhasnagar-421003</strong></p>
                          <p>
                            A/C Name :
                            <strong class="acname">Deepak Travel World</strong>
                          </p>
                          <p>A/C No : <strong class="acno">915020010735542</strong></p>
                          
                          <p>RTGS/ NEFT IFSC: <strong class='code'>UTIB0000605</strong></p>
                        </div>
                      </div>
                      <!-- <div class="mt-3">
                      <h5>UPI</h5>
                      <p>UPI ID: <strong>sample@bankid</strong></p>
                      </div> -->
                      <p class="mt-5">
                        Once a payment has been made, you can inform us at
                        sales@hotellele.com or md@hotellele.com and we will
                        process your order
                      </p>
                    </div>
                  </div>
                </card>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import Tabs from "../components/Tabs/Tabs";
import TabPane from "../components/Tabs/TabPane";
import { APIURLS } from "../api/constants.js";
import axios from "axios";
export default {
  components: {
    Tabs,
    TabPane,
  },
  data() {
    return {
      orderid: "",
      name: "",
      date:"",
      status:"",
    };
  },
  methods: {
    getOrderDetail() {
      var formData = new FormData();
      var uid = localStorage.getItem("userid");

      formData.append("orderid", this.orderid);
      formData.append("userid", uid);
      
      axios
        .post(APIURLS.GET_ORDER_DETAIL + "/" + this.orderid, formData)
        .then((response) => {
          this.showLoading = false;
          var data = response.data;
          if (response.status == 200) {
            if (data != "NANA") {
            }
          } else {
          }
          //console.log(response.data);
          var data = response.data;
          this.date=data.date;
          this.status=data.status_name;
         //console.log(status);

        });
    },
  },
  created() {
    if (this.$route.query.orderid) {
      this.orderid = this.$route.query.orderid;
    }
    var n = localStorage.getItem("name");
    if (n != null) {
      if (n != "") {
        this.name = n;
        this.getOrderDetail();
      }
    } else {
    }
  },
  mounted() {
    if (this.$route.query.orderid) {
      //this.orderid = this.$route.query.orderid;
    }
    var n = localStorage.getItem("name");
    if (n != null) {
      if (n != "") {
        this.name = n;
        this.getOrderDetail();
      }
    } else {
    }
  },
};
</script>
<style scoped>
.alert{font-size: 2rem;}
.bankname{    background: #f7dc69;
    padding-top: 0.5rem;
    
    height: 50px;
    border-bottom-left-radius: 50%;
    border-bottom-right-radius: 50%;
    text-align: center;
    color: #083578;
    font-weight: 800;
    width: 94%;
    }
    .box{border: 1px solid #f7dc69;
    border-radius: 15px;
    padding-bottom: 2%;
    padding: 0 0.2rem 0.9rem;
    max-width: 47%;
    margin-right: 2rem;
    padding-left: 2rem;}
    .branch{margin-left: 10rem;}
    .acname{margin-left: 8.5rem;}
    .acno{margin-left: 9.9rem;}
    .code{margin-left: 5.8rem;}
</style>